export const FILE_EXTENSIONS = {
  text: [".txt", ".log", ".csv", ".json"],

  code: [
    ".js",
    ".jsx",
    ".ts",
    ".tsx",
    ".py",
    ".java",
    ".cpp",
    ".c",
    ".php",
    ".go",
    ".ruby",
    ".swift",
    ".kt",
    ".scala",
    ".rust",
    ".vb",
    ".cs",
    ".sql",
    ".css",
    ".html",
    ".vue",
    ".sass",
    ".scss",
    ".less",
  ],

  config: [".ini", ".conf", ".yaml", ".yml", ".xml", ".properties", ".env"],

  docs: [".md", ".markdown", ".rst", ".docx", ".pdf", ".html", ".htm"],

  multimedia: [
    ".jpg",
    ".jpeg",
    ".png",
    ".gif",
    ".bmp",
    ".svg",
    ".mp3",
    ".wav",
    ".ogg",
    ".flac",
    ".aac",
    ".mp4",
    ".avi",
    ".mov",
    ".mkv",
  ],

  minify: [".zip", ".rar", ".tar", ".gz", ".bz2", ".xz", ".7z"],

  executable: [".exe", ".msi", ".apk", ".ipa", ".deb", ".rpm"],

  database: [".db", ".sqlite", ".mdb", ".accdb", ".sqlitedb", ".sql"],

  office: [
    ".doc",
    ".xls",
    ".ppt",
    ".xlsx",
    ".xlsm",
    ".xltx",
    ".xltm",
    ".pptx",
    ".pptm",
    ".potx",
    ".ppsx",
    ".ppam",
  ],

  videogame: [".sav", ".dat", ".pak", ".unitypackage"],

  os: [".dll", ".so", ".dylib", ".framework"],
};
